import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { FlexContainer } from "BaseComponents/Flex/FlexContainer";
import { Ingress } from "BaseComponents/Text";
import { MultipleAnimation } from "Animations";
import {CookieBlock} from "Components/Cookie/CookieBlock";
import { PageWrapper } from "BaseComponents/Wrappers";
import { H1 } from "BaseComponents/Text/";

let CookieListPage = ({ Heading, CookieBlocks, Preamble, ...rest }) => {
	return (
		<>
			<FlexContainer
				column
				maxwidth="1075px"
				margin="0 auto 2rem auto"
				smallmargin="0 auto 1rem auto"
			>
				<H1 margin="0 0 2rem 0">{Heading}</H1>
				{Preamble.length > 0 && (
					<FlexContainer maxwidth="700px" margin="0 0 2rem 0">
						<Ingress>{Preamble}</Ingress>
					</FlexContainer>
				)}
				<MultipleAnimation items={CookieBlocks}>
					<CookieBlock {...rest} />
				</MultipleAnimation>
			</FlexContainer>
		</>
	);
};

CookieListPage.propTypes = {
	Heading: PropTypes.string,
	CookieBlocks: PropTypes.array,
};

export default CookieListPage;
